import { TrackingLineColor, TrackingLineWidth, TrackingService } from './../../../providers/tracking.service';
import { Product } from "../map-factory";
import L from 'leaflet';
import * as LO from 'leaflet.offline';
import { DeviceOrientation, DeviceOrientationCompassHeading } from '@ionic-native/device-orientation';
import 'leaflet-rotatedmarker';
import { AppInjector } from '../../../app/app.module';
import { Platform } from 'ionic-angular';

declare var google;

export class LeafletProduct implements Product {
    public static map: any;
    marker: any = null;
    startMarker: any = null;
    finishMarker: any = null;
    nearestCompetitors: any = [];
    deviceOrientation = AppInjector.get(DeviceOrientation);
    platform = AppInjector.get(Platform);
    trackingService = AppInjector.get(TrackingService);

    config = {
        marker: null,
        polyLinesInner: null,
        polyLinesOuter: null,
        polyDestinations: [],
        prevDestination: null,
        map: null,
        colored: false,
        hLines: null
    };

    private static instance: LeafletProduct;

    private constructor(map) {
        LeafletProduct.map = map;
        console.log('leaflet contructor')
        this.platform.ready().then(() => {
            if (!this.platform.is('cordova')) {
                console.log('Only cordova devices support device orientation');
                return;
            }
            console.log('leaflet cordova in');
            this.deviceOrientation.watchHeading().subscribe((data: DeviceOrientationCompassHeading) => {
                // console.log('deviceOrientation.watchHeading: ' + JSON.stringify(data));
                if (this.marker) {
                    this.marker.setRotationAngle(data.trueHeading);
                    // console.log('marker set angle...');
                }
            }, (err) => {
                console.log("error while watching heading: " + JSON.stringify(err));
            });

        });
    }

    public static getInstance(map?): LeafletProduct {
        if (!LeafletProduct.instance) {
            LeafletProduct.instance = new LeafletProduct(map);
        }

        LeafletProduct.map = map;
        return LeafletProduct.instance;
    }

    newPoly() {
        if (this.getPolyLines() || this.getPolyLinesOuter()) {
            this.getMap().removeLayer(this.getPolyLines());
            this.getMap().removeLayer(this.getPolyLinesOuter());
        }
        this.setPolyDestinations([]);
    }

    addPolyDestination(coords, index?: any) {
        if (this.getMap()) {

            let lat = coords._latitude || coords.latitude || coords.coords.latitude;
            let lng = coords._longitude || coords.longitude || coords.coords.longitude;

            if (!index) {
                this.getPolyDestinations().push([lat, lng]);
            } else {
                this.getPolyDestinations()[index] = [lat, lng];
            }
        }
    }

    removeAllPath() {
        for (let i in LeafletProduct.map._layers) {
            if (LeafletProduct.map._layers[i]._path != undefined) {
                try {
                    LeafletProduct.map.removeLayer(LeafletProduct.map._layers[i]);
                }
                catch (e) {
                    console.log("problem with " + e + LeafletProduct.map._layers[i]);
                }
            }
        }
    }

    // DONE, no custom icon...
    positionMarker(o) {
        if (this.getMap() && typeof o !== "undefined" && o) {
            let lat = o.coords.latitude;
            let lng = o.coords.longitude;

            if (this.marker) {
                // this.getMap().removeLayer(this.marker);
                this.marker.setLatLng(L.latLng(lat, lng));
            } else {
                let myIcon = new L.Icon({
                    iconUrl: 'assets/imgs/marker/mapping/' + this.getMarkerColor() + '.gif',
                    iconSize: [this.getMarkerColor().includes('blue') ? 32 : 44, 44],
                    iconAnchor: [this.getMarkerColor().includes('blue') ? 16 : 22, 22],
                });

                this.marker = (L as any).marker([lat, lng], {
                    icon: myIcon,
                    rotationAngle: 0,
                    zIndexOffset: 9999
                });
                this.marker.addTo(this.getMap());
            }
            this.setMapCenter(o);
        }
    }


    getMarkerColor() {
        switch (this.trackingService.options.trackingColor) {
            case TrackingLineColor.BLACK_COLOR: return "black";
            case TrackingLineColor.BLUE_COLOR: return "blue";
            case TrackingLineColor.GREEN_COLOR: return "green";
            case TrackingLineColor.RED_COLOR: return "red";
            default: return "blue";
        }
    }

    flyTo(location: any) {
        if (this.getMap()) this.getMap().flyTo(L.latLng(location.latitude, location.longitude));
    }

    // -
    positionNearestCompetitors(competitor) {
        if (this.getMap() && competitor.length == 1 && competitor[0].position == "right") {
            this.deleteMarkers();
            let map = this.getMap();
            // let content2 = '<img style="background-color:transparent;width:35px;height:35px;border: 3px solid grey; border-radius: 50%; overflow:hidden;" src="' + competitor[0].image + '"><p style="margin-top: 3px;font-size: 9px; width:40px;">Pl ' + competitor[0].place + '  ' + competitor[0].time.toFixed(0) + 's</p>'
            let content2=`
                        <div style="position:relative;background:transparent;width:50px;height:50px;">
                            <img style="background:transparent;width:60px;height:60px;" src="/assets/imgs/leaflet/location-marker.png">
                            <img style="position:absolute; top: 12px; left:20px; background:transparent;width:20px;height:20px; border-radius: 50%; overflow:hidden;" src="' + ${competitor[0].image} + '">
                            <div style="display: block; margin-top: -5px;font-size: 9px; color: #000; max-width: 60px;">
                            <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">Pl  ${competitor[0].place}</div> <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">${competitor[0].time.toFixed(0)} s</div>
                            </div>
                        </div>`
            let marker =new L.Marker([0,0])
            let icon =L.divIcon({
                html: content2,
                iconSize:[45,45],
                className:'competitor-icon'
            })
            marker.setIcon(icon)
            marker.addTo(map)
            marker.setLatLng(L.latLng(competitor[0].coords.latitude, competitor[0].coords.longitude))
            this.nearestCompetitors.push(marker);
        }

        if (this.getMap() && competitor.length == 1 && competitor[0].position == "left") {
            this.deleteMarkers();
            let map = this.getMap();
            // // img.src = "/assets/imgs/leaflet/location-marker.png";
            let content1=`
                        <div style="position:relative;background:transparent;width:50px;height:50px;">
                            <img style="background:transparent;width:60px;height:60px;" src="/assets/imgs/leaflet/location-marker.png">
                            <img style="position:absolute; top: 12px; left:20px; background:transparent;width:20px;height:20px; border-radius: 50%; overflow:hidden;" src="' + ${competitor[0].image} + '">
                            <div style="display: block; margin-top: -5px;font-size: 9px; color: #000; max-width: 60px;">
                            <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">Pl  ${competitor[0].place}</div> <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">${competitor[0].time.toFixed(0)} s</div>
                            </div>
                        </div>`
            // let content1 ='<img style="background:transparent;width:50px;height:50px;" src="/assets/imgs/leaflet/location-marker.png"> <img style="background:transparent;width:30px;height:30px; border-radius: 50%; overflow:hidden;" src="' + competitor[0].image + '"><p style="margin-top: -3px;font-size: 9px; color: #fff;">Pl ' + competitor[0].place + '  ' + competitor[0].time.toFixed(0) + 's</p>'
            // let content1 = '<img style="background:transparent;width:35px;height:35px;border: 3px solid grey; border-radius: 50%; overflow:hidden;" src="' + competitor[0].image + '"><p style="margin-top: -3px;font-size: 9px;">Pl ' + competitor[0].place + '  ' + competitor[0].time + 's</p>'

            let marker =new L.Marker([0,0])
            let icon =L.divIcon({
                html:content1,
                iconSize:[45,45],
                className:'competitor-icon'
            })
            marker.setIcon(icon)
            marker.addTo(map)
            marker.setLatLng(L.latLng(competitor[0].coords[0], competitor[0].coords[1]))
            this.nearestCompetitors.push(marker);
        }

        if (this.getMap() && competitor.length == 2) {
            this.deleteMarkers();
            // let content1 = '<img style="background:transparent;width:35px;height:35px;border: 3px solid grey; border-radius: 50%; overflow:hidden;" src="' + competitor[0].image + '"><p style="margin-top: -3px;font-size: 9px; width:50px;">Pl ' + competitor[0].place + '  ' + competitor[0].time.toFixed(0) + 's</p>'
            let content1=`<div style="position:relative;background:transparent;width:50px;height:50px;">
                            <img style="background:transparent;width:60px;height:60px;" src="/assets/imgs/leaflet/location-marker.png">
                            <img style="position:absolute; top: 12px; left:20px; background:transparent;width:20px;height:20px; border-radius: 50%; overflow:hidden;" src="' + ${competitor[0].image} + '">
                            <div style="display: block; margin-top: -5px;font-size: 9px; color: #000; max-width: 60px;">
                            <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">Pl  ${competitor[0].place}</div> <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">${competitor[0].time.toFixed(0)} s</div>
                            </div>
                        </div>`
            // let content2 = '<img style="background:transparent;width:35px;height:35px;border: 3px solid grey; border-radius: 50%; overflow:hidden;" src="' + competitor[1].image + '"><p style="margin-top: -3px;font-size: 9px; width:50px;">Pl ' + competitor[1].place + '  ' + competitor[1].time.toFixed(0) + 's</p>'
            let content2=`<div style="position:relative;background:transparent;width:50px;height:50px;">
                            <img style="background:transparent;width:60px;height:60px;" src="/assets/imgs/leaflet/location-marker.png">
                            <img style="position:absolute; top: 12px; left:20px; background:transparent;width:20px;height:20px; border-radius: 50%; overflow:hidden;" src="' + ${competitor[1].image} + '">
                            <div style="display: block; margin-top: -5px;font-size: 9px; color: #000; max-width: 60px;">
                            <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">Pl  ${competitor[1].place}</div> <div style="max-width: 25px; background-color: #fff; margin: 0 auto; text-align: center;">${competitor[1].time.toFixed(0)} s</div>
                            </div>
                        </div>`
            console.log('competitor', JSON.stringify(competitor[1]))
            let map = this.getMap();
            //for marker 1
            let marker1 =new L.Marker([0,0])
            let icon1 =L.divIcon({
                html:content1,
                iconSize:[50,50],
                className:'competitor-icon'
            })
                marker1.setIcon(icon1)
                marker1.addTo(map)
                marker1.setLatLng(L.latLng(competitor[0].coords.latitude, competitor[0].coords.longitude))

            this.nearestCompetitors.push(marker1);
           //for marker 2
            let marker2 =new L.Marker([0,0])
            let icon2 =L.divIcon({
                html:content2,
                iconSize:[50,50],
                className:'competitor-icon'
            })
            marker2.setIcon(icon2)
            marker2.addTo(map)
            marker2.setLatLng(L.latLng(competitor[1].coords[0], competitor[1].coords[1]))

            this.nearestCompetitors.push(marker2);

        }

    }

    preloadMap(path): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            let time = 400;
            let i = 0;

            let timer = setInterval(() => {
                this.getMap().setView(new L.LatLng(path[i].lat(), path[i].lng()));
                i += 2;

                if (i >= path.length) {
                    if (this.marker) {
                        let latlng = this.marker.getLatLng();
                        this.getMap().setView(new L.LatLng(latlng.lat, latlng.lng));
                    }

                    clearInterval(timer);
                    resolve(null);
                }
            }, time);
        });
    }

    // DONE
    setMapOnAll(map?) {
        for (let i = 0; i < this.nearestCompetitors.length; i++) {
            this.getMap().removeLayer(this.nearestCompetitors[i]);
        }
    }

    // DONE
    clearMarkers() {
        this.setMapOnAll(null);
    }

    clearMeMarker() {
        this.marker = null;
        LeafletProduct.map.eachLayer(function (layer) {
            if (layer instanceof L.Marker) {
                let layerIcon = layer.getIcon();

                if (!layerIcon.options.iconUrl.includes("laufen") && !layerIcon.options.iconUrl.includes("ziel"))
                    layer.remove();
            }
        });
    }

    // DONE
    showMarkers() {
        this.setMapOnAll(this.getMap());
    }

    clearNearestMarkers() {
        if (this.startMarker) {
            this.getMap().removeLayer(this.startMarker);
        }
        if (this.finishMarker) {
            this.getMap().removeLayer(this.finishMarker);
        }
    }

    // DONE
    deleteMarkers() {
        this.clearMarkers();
        this.nearestCompetitors = [];
    }

    // DONE
    setMapCenter(o, zoom?) {
        if (typeof o == "undefined") return;
        let lat = o.coords.latitude;
        let lng = o.coords.longitude;
        if (typeof LeafletProduct.map !== "undefined") {
            if (zoom) {
                this.getMap().setView(new L.LatLng(lat, lng), zoom);
            } else {
                this.getMap().setView(new L.LatLng(lat, lng));
            }
        }
    }

    setMapCenterLatLng(coords, zoom: number = 16) {
        if (typeof coords === "undefined") return;

        let lat;
        let lng;
        if (typeof coords.lat == "function") {
            lat = coords.lat();
            lng = coords.lng();
        } else if (coords.length == 2) {
            lat = coords[0];
            lng = coords[1];
        } else {
            lat = coords.lat;
            lng = coords.lng;
        }
        this.getMap().setView(new L.LatLng(lat, lng), zoom);
    }

    setMapCenterZoom(zoom) {
        let lat = this.getCenter().lat
        let lng = this.getCenter().lng;
        if (this.getMap()) {
            this.getMap().setView(new L.LatLng(lat, lng), zoom);
        }
    }

    // DONE
    drawPolyLines(isCustom: boolean = false) {
        if (this.getMap()) {
            if (this.getPolyLines()) {
                this.getMap().removeLayer(this.getPolyLines());
                delete this.config.polyLinesInner;
                this.getMap().removeLayer(this.getPolyLinesOuter());
                delete this.config.polyLinesOuter;
            }
            this.setPolyDraw(isCustom);
        }
    }

    disableZoom() {
        console.log('disable-zoom-start');
        this.getMap().touchZoom.disable();
        this.getMap().doubleClickZoom.disable();
        this.getMap().scrollWheelZoom.disable();
        this.getMap().boxZoom.disable();
        this.getMap().keyboard.disable();
        console.log('disable-zoom-finish');
        this.getMap().zoomControl.disable();
    }

    // DONE
    setMap(map) {
        LeafletProduct.map = map;
    }

    // DONE
    getMap() {
        return LeafletProduct.map;
    }

    // DONE
    getCenter() {
        return LeafletProduct.map.getCenter();
    }

    // DONE
    async setPolyDraw(isCustom) {
        let array = this.getPolyDestinations();
        if (array.length == 0) return;

        let formattedArray = this.format(array);
        if (isCustom) {
            let lineWidth = this.getLineWeight();
            let lineColor = this.getLineColor();
            this.config.polyLinesInner = L.polyline(formattedArray as [number, number][], { color: lineColor.inner, weight: lineWidth.inner, opacity: 1 }).addTo(this.getMap());
            this.config.polyLinesOuter = L.polyline(formattedArray as [number, number][], { color: lineColor.outer, weight: lineWidth.outer, opacity: 1 }).addTo(this.getMap());
        } else {
            this.config.polyLinesInner = L.polyline(formattedArray as [number, number][], { color: '#122c5c', weight: 6, opacity: 1 }).addTo(this.getMap());
            this.config.polyLinesOuter = L.polyline(formattedArray as [number, number][], { color: '#294f94', weight: 3, opacity: 1 }).addTo(this.getMap());
        }
    }

    private getLineWeight() {
        switch (this.trackingService.options.lineWidth) {
            case TrackingLineWidth.TRACKING_LINE_SLIM: return { inner: 7, outer: 4 };
            case TrackingLineWidth.TRACKING_LINE_NORMAL: return { inner: 10, outer: 6 };
            case TrackingLineWidth.TRACKING_LINE_BROAD: return { inner: 13, outer: 8 };
            default: return { inner: 6, outer: 3 };
        }
    }
    private getLineColor() {
        switch (this.trackingService.options.trackingColor) {
            case TrackingLineColor.BLACK_COLOR: return { inner: "#000000", outer: "#4D4D4D" };
            case TrackingLineColor.BLUE_COLOR: return { inner: "#122c5c", outer: "#294f94" };
            case TrackingLineColor.GREEN_COLOR: return { inner: "#4b6043", outer: "#87ab69" };
            case TrackingLineColor.RED_COLOR: return { inner: "#c30010", outer: "#ee6b6e" };
            default: return { inner: "#122c5c", outer: "#294f94" };
        }
    }

    format(_array) {
        if (_array.length == 0) return;

        let array = [];
        if (typeof _array[0].lat === "function") {
            for (let i = 0; i < _array.length; i++) {
                array.push([_array[i].lat(), _array[i].lng()]);
            }
            return array;
        }
        return _array;
    }

    // DONE
    getPolyLines() {
        return this.config.polyLinesInner;
    }

    getPolyLinesOuter() {
        return this.config.polyLinesOuter;
    }

    // DONE
    setPolyDestinations(o) {
        this.config.polyDestinations = Object.assign([], o);
    }

    // DONE
    getPolyDestinations() {
        return this.config.polyDestinations;
    }

    drawStartFinishMarkersLatLng(coords, icons) {
        console.log('drawStartFinishMarkers: ');
        let startIcon = new L.Icon({
            iconUrl: icons.start,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        })

        if(typeof coords[0] === "object"){
            this.startMarker = new L.Marker([coords[0][0], coords[0][1]], {
                icon: startIcon
            });
        }else{
            this.startMarker = new L.Marker([coords[0].lat(), coords[0].lng()], {
                icon: startIcon
            });
        }
        let finishIcon = new L.Icon({
            iconUrl: icons.finish,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        })
        if (typeof coords[1] === "object"){
            this.finishMarker = new L.Marker([coords[1][0], coords[1][1]], {
                icon: finishIcon
            });
        }else{
            this.finishMarker = new L.Marker([coords[1].lat(), coords[1].lng()], {
                icon: finishIcon
            });
        }

        this.startMarker.addTo(this.getMap());
        this.finishMarker.addTo(this.getMap());
    }

    drawStartFinishMarkersArray(coords, icons) {
        console.log('drawStartFinishMarkers: ');
        let startIcon = new L.Icon({
            iconUrl: icons.start,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        })
        this.startMarker = new L.Marker([coords[0][0], coords[0][1]], {
            icon: startIcon
        });
        let finishIcon = new L.Icon({
            iconUrl: icons.finish,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        })
        this.finishMarker = new L.Marker([coords[1][0], coords[1][1]], {
            icon: finishIcon
        });

        this.startMarker.addTo(this.getMap());
        this.finishMarker.addTo(this.getMap());
    }

    destroy(){
        LeafletProduct.instance = null;
    }
}


// WEBPACK FOOTER //
// /src/tracker/map-factory/map-products/leaflet-product.ts